import { baseApi } from "../baseApi";

export const packingSlip = baseApi.injectEndpoints({
     endpoints: (builder) => ({
    postCreatePackingSlip: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.auto_create_packing_slip`,
        method: 'POST',
        body: payload,
      }),
          providesTags: ['packing']
    }),

    postGetPackingSlipDetail: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_packing_slip_detail`,
        method: 'POST',
        body: payload,
      }),
        providesTags: ['packing']
    }),

    postSubmitPackingSlip: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_packing_slip`,
        method: 'POST',
        body: payload,
      }),
        invalidatesTags: ['packing']
    }),
    postGetPackingSlipList: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_packing_slip_list`,
        method: 'POST',
        body: payload,
      }),
      providesTags: ['packing']
    }),
     postGetPackingSlipByName: builder.mutation({
      query: (payload) => ({
        url: `/api/method/frappe.client.get`,
        method: 'POST',
        body: payload,
      }),
    }),
getPackingSlipCount: builder.query({
      query: (deliveryNote) => {
        const filters = encodeURIComponent(
          JSON.stringify([["Packing Slip", "delivery_note", "=", deliveryNote]])
        );
        const doctype = encodeURIComponent("Packing Slip");
        return `/api/method/frappe.desk.reportview.get_count?filters=${filters}&doctype=${doctype}`;
      },
    }),

postUpdatePackingSlip: builder.mutation({
  query: (payload) => ({
    url: `/api/method/stackerbee_mobile_wms.wms.api.update_packing_slip`,
    method: 'POST',
    body: payload,
  }),
  invalidatesTags: ['packing']
}),


  }),
});

export const { usePostCreatePackingSlipMutation,
  usePostGetPackingSlipDetailMutation,
  usePostSubmitPackingSlipMutation,
  usePostGetPackingSlipListMutation,
  usePostGetPackingSlipByNameMutation,
  useGetPackingSlipCountQuery,
  usePostUpdatePackingSlipMutation,
  useLazyGetPackingSlipCountQuery } = packingSlip;

